module.exports = __webpack_public_path__ + "media/images/icons/twotone/stop-a65d5652a39f1e8987ce6304801e14d4.svg";